import { component, getter, action } from '../../decorators';

import WbHeader from '../header/header.vue';
import NotFound from '../404/404.vue';

import Spinner from '../../components/common/spinner/spinner.vue';
import ShowCard from '../../components/common/show-card/show-card.vue';

import { SHOWS_LOAD, SHOW_EXIT } from '../../store/actions';

@component({
   name: 'Shows',
   components: { Spinner, ShowCard, WbHeader, NotFound },
   watch: {
      isCurrentPage: 'onChangePage'
   }
})
export default class Shows {
   @getter() getAllShows
   @getter() isShowLoading

   @action(SHOWS_LOAD) loadShows
   @action(SHOW_EXIT) clearCurrentShow

   get isCurrentPage() {
      return this.$route.name === 'Shows';
   }

   get notFoundReason() {
      return this.$store.state.shows.notFoundReason;
   }

   onChangePage(isCurrentPage) {
      if (isCurrentPage) {
         this.clearCurrentShow();
      }
   }

   goto(show) {
      this.$router.push({name: 'Search', params: { mid: show.route ? show.route : show.id } });
   }

   created() {
      this.clearCurrentShow();
      this.loadShows();
   }
}
